module.exports = __webpack_public_path__ + "img/sh-slide.7bbc733a.png";